import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Award, X } from "lucide-react";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";

export default function CheckoutLoyaltySection({ tc, availableRewards, loyalty, onLoyaltyChange }) {
  const { t } = useTranslation();
  if (!availableRewards.length && !loyalty?.reward) return null;
  return (
    <div>
      <Label className="text-xs font-semibold uppercase" style={{ color: tc.primary }}>
        <Award className="w-3 h-3 inline mr-1" />{t("checkout.myCredits")}
      </Label>
      {loyalty?.reward ? (
        <div className="flex items-center justify-between mt-1.5 p-3 rounded-xl border-2" style={{ borderColor: tc.primary, backgroundColor: `${tc.primary}08` }}>
          <div>
            <p className="text-sm font-bold" style={{ color: tc.primary }}>✅ {loyalty.reward.reward}</p>
            <p className="text-xs text-gray-500 mt-0.5">{loyalty.reward.points_required} {t("checkout.pointsUsed")}</p>
          </div>
          <Button variant="ghost" size="sm" className="h-8 w-8 p-0 text-gray-400 hover:text-red-500" onClick={() => onLoyaltyChange(null)}>
            <X className="w-4 h-4" />
          </Button>
        </div>
      ) : (
        <div className="mt-1.5 space-y-2">
          {availableRewards.map(r => (
            <button key={r.id} onClick={() => { onLoyaltyChange(r); toast.success(`Crédito aplicado: ${r.reward}`); }}
              className="w-full flex items-center justify-between p-3 rounded-xl border-2 border-amber-300 bg-amber-50 hover:bg-amber-100 active:scale-[0.98] transition-all text-left"
              data-testid={`loyalty-reward-${r.id}`}>
              <div>
                <p className="text-sm font-black text-amber-900">{r.reward}</p>
                <p className="text-xs text-amber-600 mt-0.5">{r.points_required} {t("checkout.pointsTap")}</p>
              </div>
              <div className="shrink-0 ml-2 px-3 py-1.5 rounded-lg bg-amber-500 text-white text-xs font-bold">
                {t("checkout.useReward")}
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
